import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    onSession: false
  },
  mutations: {
    changeSession(state, payload) {
      state.onSession = payload;
    }
  },
  actions: {},
  modules: {}
});
